<template>
  <el-main class="p-0 custom_main custom-scroll inverted">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </el-main>
</template>
<script>
export default {
  name: "Content",
  created() {
    this.$root.$on("mensaje", (t, m) => this.msg(t, m));
  },
  beforeDestroy() {
    this.$root.$off("mensaje", (t, m) => this.msg(t, m));
  },
  methods: {
    msg(type, message) {
      this.$notify({
        title: "Success",
        message: message,
        type: type,
      });
    },
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom_main {
  height: calc(100vh);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Content.vue